import { render, staticRenderFns } from "./ResetPasswordAsk.vue?vue&type=template&id=4dbbdb99&scoped=true&"
import script from "./ResetPasswordAsk.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordAsk.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordAsk.vue?vue&type=style&index=0&id=4dbbdb99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbdb99",
  null
  
)

export default component.exports